<template>
  <div class="tabs my-2 " >
    <div class="tab-buttons">
        <div class="d-flex justify-content-between">
          <div class="p-2 d-flex flex-row">
              <b-icon-plus-lg scale="1.2" class="cursorPoint plus mt-1 mr-1" @click="insertAddress()"></b-icon-plus-lg>&nbsp;
              <s-confirmation-button v-if="!isDeleteAddressBtnHidden"  
                  ref="confirmBtn"
                  :showIconOnly=true
                  :messages="customMessages"
                  @confirmation-success="removeAddress()"
                  :variant="getTheme.olight"
              >
                  <template v-slot:icon>
                      <b-icon-trash :variant="getTheme.danger" font-scale="1"></b-icon-trash>
                  </template>
              </s-confirmation-button>
          </div>
          <div class="p-2">
            <span v-if="showInactiveAddresses" class="moins">{{ $t('cc_AddressesInactives')}}</span>
            <span v-if="!showInactiveAddresses" class="plus">{{ $t('cc_AddressesActives')}}</span><br/>
          </div>
          <div class="p-2 d-flex flex-row-reverse">
            <b-form-checkbox v-if="isInactiveAddressesExists" switch size="lg" v-model="showInactiveAddresses" class="cursorPoint" />
          </div>
        </div>

        <span v-for="(address, index) in getAddressList" :key="index">
            <!-- <span v-if="(address.label != '' && address.id > 0) || (address.label != '' && this.parentId == 0)"> -->
            <span v-if="(address.label != '') || (address.label != '' && this.parentId == 0)">
              <b-button v-if="address.isAddressValid"
                  :class="{ 'active': addressIndex == index, 'custom-button': true }"
                  @click="changeTab(index)"
              >
                  <div>
                    {{ address.label }}
                  </div>
              </b-button>
            </span>
        </span>

        <template v-if="currentAddress">
          <!-- Libellé de l'adresse -->
          <s-input :disabled="!currentAddress.isActive" id = "label" name="label" type="text" maxlength="40" class="MargeTop15" :placeholder="$t('cc_Emplacement')" v-capitalize v-model="currentAddress.label" :state="currentAddress.label.length > 0"></s-input>
          <!-- L'adresse -->
          <s-input :disabled="!currentAddress.isActive" id = "add1" name="add1" type="text" maxlength="40" class="MargeTop15" :placeholder="$t('cc_Adresse')" v-capitalize v-model="currentAddress.address1" :state="currentAddress.address1.length > 0"></s-input>
          <!-- Ville -->
          <s-input :disabled="!currentAddress.isActive" id = "add2" name="add2" type="text" maxlength="40" class="MargeTop5" :placeholder="$t('cc_Ville')" v-capitalize v-model="currentAddress.city" :state="currentAddress.city.length > 0"></s-input>
          <b-row>
              <b-col lg="6" xl="6" xs="12" sm="12" md="12">
                <!-- Code postal -->
                  <s-input :disabled="!currentAddress.isActive" id = "zipCode" name="zipCode" type="text" maxlength="7" class="MargeTop5" :placeholder="$t('cc_CodePostal')" v-uppercase v-model="currentAddress.zipcode"></s-input>
              </b-col>
          </b-row>
          
          <b-row>
              <b-col lg="6" xl="6" xs="12" sm="12" md="12">
                  <!-- Télephone -->
                  <s-input :disabled="!currentAddress.isActive" id = "tel1" name="tel1" type="text" maxlength="15" class="MargeTop15" :placeholder="$t('cc_Telephone')" v-mask="'(999) 999 9999'" v-model="currentAddress.tel1" :state="currentAddress.tel1.length > 0"></s-input>
              </b-col>
              <b-col lg="6" xl="6" xs="12" sm="12" md="12">
                  <!-- Extension -->
                  <s-input :disabled="!currentAddress.isActive" id = "tel1Ext" name="tel1Ext" type="text" maxlength="10" class="MargeTop15" :placeholder="$t('cc_Ext')" v-model="currentAddress.tel1Ext"></s-input>
              </b-col>
          </b-row>

          <b-button style="margin-top: 10px;" :disabled="checkAllAddressFields" v-show="currentAddress.isActive" :variant="getTheme.success" @click="saveAddress()" >{{$t("g_Enregistrer")}}</b-button>
          <b-button style="margin-top: 10px;" v-show="!currentAddress.isActive" :variant="getTheme.success" @click="activateAddress()" >{{$t("cc_ReactiverAddresse")}}</b-button>
        </template>
        <template v-else>
          <br/>
          <span>{{ $t('c_NoAddressFound') }}</span>
        </template>

      </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    name: "s-tabsAddress",
    props : ['parentId','addressList'],
    data() {
      return {
        addressIndex : 0,
        currentId : 0,
        isNewAddress : true,
        showInactiveAddresses :false,
        isInactiveAddressesExists : false,
        list : [],
        originalAddress : {},
        initialActiveAddress : {
                            "id": 0,
                            "isActive": true,
                            "label": "",
                            "address1": "",
                            "address2": "",
                            "city": "",
                            "state": "",
                            "country": "",
                            "zipcode": "",
                            "tel1": "",
                            "tel1Ext": "",
                          },
        customMessages: [
          '',
          'Etes-vous sûr?',
          '',
        ],
      };
    },
    methods: {
      /**
       * Etablit le comportement par defaut après chaque action (ajout/modification/desactivation d'une addresse)
       */
      resetfields() {
        this.insertAddress()
      },
      /**
       * Quand ion decide d'afficher les addresses actifs et/ou inactives 
       * addressIndex, currentId, originalAddress sont reinitialisés en fonction de la liste filtré (getAddressList)
       */
      toogleActiveAddresses(){
        this.addressIndex = 0
        this.currentId = this.getAddressList[this.addressIndex].id
        this.originalAddress = this.$CObj(this.currentAddress)
      },
      /**
       * Ajouter une nouvelle adresse
       */
      insertAddress(){
        this.showInactiveAddresses = false
        this.isNewAddress = true;
        this.addressIndex  = 0
        this.currentId = this.currentAddress.id
      },
      /**
       * Choisir l'addresse à afficher
       */
      changeTab(index) {
          this.isNewAddress = false;
          this.addressIndex = index
          this.currentId = this.getAddressList[this.addressIndex].id
          this.originalAddress = this.$CObj(this.getAddressList[this.addressIndex])
      },
      /**
       * Supprimer (Désactiver) une addresse
       */
      removeAddress() {
        Object.assign(this.currentAddress,  {isActive: false});
        this.$emit('removeAdress', {addressId: this.currentAddress.id}  )
        this.resetfields()
      },
      /**
       * Enregistre / Modifier une addresse
       */
      saveAddress() {
        if(this.isNewAddress) {
          this.$emit('saveNewAddress', {newAddress: this.currentAddress}  ) 
        } 
        else {
          this.$emit('updateAddress', {address: this.currentAddress}  ) 
        }
        Object.assign(this.currentAddress,  {isAddressValid: true});
        this.resetfields()
      },
      /**
       * Réactiver une addresse
       */
      activateAddress() {
        Object.assign(this.currentAddress,  {isActive: true});
        this.$emit('updateAddress', {address: this.currentAddress}  )
        this.resetfields()
      },
      buildAddressList() {
        let currentList = this.addressList
        if(typeof currentList != 'undefined') {
          let ops = currentList.map((obj) => {
            let isAddressValid = (obj.label != '' && obj.address1 != '' && obj.city  != '' && obj.tel1  != '') 
            Object.assign(obj,  {isAddressValid: isAddressValid});
            return obj;
          });

          //Si il existe au moins une addresse inactive la fonction retourne true sinon elle retourne false
          let firstInactiveAddr = ops.find(address => address.isActive == false );
          this.isInactiveAddressesExists = typeof firstInactiveAddr != 'undefined'

          this.list = ops
        }
      }
    },
    computed: {
      ...mapGetters(['getTheme']),
      /**
       * Valider l'état des champs de l'addresse
       */
       checkAllAddressFields() {
        if(this.currentAddress.label != '' && 
           this.currentAddress.address1 != '' && 
           this.currentAddress.city  != '' && 
           this.currentAddress.tel1  != ''
        ) return false
        else return true
      },
      /**
       * Filter la liste des addresse à afficher
       * Le filtre s'applique en fonction de la valeur du flag 'showInactiveAddresses'
       */
      getAddressList(){
        return this.list.filter(address => address.isActive == !this.showInactiveAddresses)
      },
      currentAddress() {
       return this.getAddressList[this.addressIndex]
      },

      /**
       * Si toutes les adresses sont inactives, retourne true sinon elle retourne false
       */
       isDeleteAddressBtnHidden() {
        //let countInactiveAddr=0
        //countInactiveAddr = this.addressList.filter(address => address.isActive == false )?.length;
        //return ((countInactiveAddr == this.countAllAddr) || this.currentId == 0 || this.showInactiveAddresses)
        return ( this.currentId == 0 )
      }
      
    },
    mounted() {
      this.buildAddressList()
    },
    watch: {
      showInactiveAddresses() {
        this.toogleActiveAddresses()
      },
      isInactiveAddressesExists(newValue) {
        if(!newValue) {
          this.showInactiveAddresses = false
        }
      },
      /*
      getAddressList : function(newValue) {
        this.resetfields()
        this.$emit('update:addressList', newValue)
      }
      */
      addressList : function() {
        this.buildAddressList()
      }
    }
};
</script>

<style>

.plus{
  color: green;
}
.moins{
  color: red;
}
.deleted{
  color: rgba(184, 120, 52, 0.345);
}

.custom-button {
    height: 20px;
    border: none;
    border-radius: 5px;
    background-color: #ccc;
    color: #333;
    font-size: 12px;
    padding: 0px 12px;
    margin: 3px;
}

.custom-button2 {
    padding-top: 0px;
    padding-left: 5px;
    height: 20px;
    width: 20px;
    border: none;
    border-radius: 5px;
    background-color: #ccc;
    color: #333;
    font-size: 16px;
    margin-right: 5px;
}

.tabs {
  /* Styles pour les onglets */
}

.tab-buttons {
  /* Styles pour les boutons d'onglet */
}

.tab-buttons button {
  /* Styles pour chaque bouton d'onglet */
}

.tab-buttons button.active {
  /* Styles pour le bouton d'onglet actif */
}

.tab-content {
  /* Styles pour le contenu des onglets */
}

.tab-content div {
  /* Styles pour chaque contenu d'onglet */
}
</style>